import React, {useState, useEffect, useRef} from "react";
import {Col} from "../../styles/Grid";
import DynamicInput, {Label} from "./DynamicInput";
import styled from "styled-components";
import {flexCreator} from "../../hooks/helpers";
import {ReactComponent as UploadIcon} from "../../assets/icons/upload.svg";
import {ReactComponent as CancelIcon} from "../../assets/icons/cancel.svg";
import {ResetButton} from "../../styles/Butttons";

export default function EditableImg({value, change, title, editable, label, name, fileName, type}) {
   const [currentName, setName] = useState("");
   const [currentReadName, setReadName] = useState("");
   const inputFile = useRef(null);

   useEffect(() => {
      setnewName();
   }, [fileName]);

   const changeStatus = (e) => {
      if (!e.target.files) return false;
      let newName = e.target.files[0].name;
      if (change) {
         change(e);
      }
      if (newName.length > 20) {
         newName = newName.substr(newName.length - 8);
      }
      setName(newName);
   };

   const cleanValues = () => {
      inputFile.current.value = null;
      setName("");
   };

   const setnewName = () => {
      if (!fileName) return null;
      let splitValue = fileName.split("/");
      setName(splitValue[splitValue.length - 1]);
   };

   if (editable) {
      return (
         <CoLInput large={6} className="row">
            <Label className="label align">{label ? label + ":" : ""}</Label>
            <InputLine>
               <Col large={12} className="NameDiv">
                  <LabelName>{currentName}</LabelName>
                  {currentName && (
                     <ResetButton color="plum" onClick={cleanValues}>
                        <CancelIcon width="1em" height="1em" fill="crimson" />
                     </ResetButton>
                  )}
               </Col>

               <InputFileStyled>
                  {type === "video" ? (
                     <input type="file" ref={inputFile} id={name} name={name} accept=".mp4" onChange={changeStatus} />
                  ) : (
                     <input type="file" ref={inputFile} id={name} name={name} accept=".jpg, .jpeg" onChange={changeStatus} />
                  )}
                  <ButtonInput htmlFor={name}>
                     <UploadIcon width="1em" height="1em" fill="red" />
                     <span>Subir archivo</span>
                  </ButtonInput>
                  {type === "video" ? (
                     <>
                        <LabelName>
                           Archivos permitidos: <b>.mp4</b>
                        </LabelName>
                        <br />
                        <LabelName>
                           Peso max. recomendado: <b>25 mb</b>
                        </LabelName>
                     </>
                  ) : (
                     <LabelName>
                        Archivo permitido: <b>.jpg</b>, <b>.jpeg</b>
                     </LabelName>
                  )}
               </InputFileStyled>
            </InputLine>
         </CoLInput>
      );
   }

   return (
      <CoLInput large={6} className="row aaaa">
         <Label className="label align">{title}:</Label>
         <InputLine>
            <DynamicInput editable={false} value={currentName} />
         </InputLine>
      </CoLInput>
   );
}

const InputLine = styled.div`
   margin-top: 0.7em;
   ${flexCreator("between", "center")};
   padding-right: 2em;
   user-select: none;

   & ${ResetButton} {
      width: 1em;
   }
`;

const CoLInput = styled(Col)`
   display: flex;
   flex-direction: column;

   & ${InputLine} {
      display: flex;
      flex-direction: column;
   }

   & .NameDiv {
      display: flex;
   }
`;

const LabelName = styled(Label)`
   font-size: 0.8em;
   font-weight: 200;
   width: 50%;
   display: block;
   user-select: none;
`;

const ButtonInput = styled.label`
   background: transparent;
   display: block;
   width: 120px;
   border: 1px solid #1c355e;
   padding: 1px 0.4em;
   cursor: cell;
   user-select: none;
   margin: 0.5em 0;

   display: flex;
   align-items: center;
   justify-content: space-around;

   span {
      font-size: 0.9em;
      font-weight: 300;
      color: grey;
   }
`;

const InputFileStyled = styled.div`
   user-select: none;

   & p {
      width: 100%;
      display: inline;
      font-size: 0.75em;
      margin-top: 0.3em;
   }

   input {
      display: none;
   }
`;
